import React from "react";
import { DesktopOutlined } from "@ant-design/icons";
import { createUseStyles } from "react-jss";
import mobileNoticeStyles from "./mobileNoticeStyles";

const useStyles = createUseStyles(mobileNoticeStyles);

const MobileNotice = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <DesktopOutlined className={classes.icon} />
      <h2 className={classes.title}>Desktop Browser Required</h2>
      <p className={classes.text}>
        The Pet Pulse Vet Portal does not support mobile view. Please open this
        app using a desktop browser like Google Chrome or Microsoft Edge.
      </p>
    </div>
  );
};

export default MobileNotice;
